import {
  formatBookingAmount,
  formatBookingDateTime,
  getBookingStatusBadgeClass,
} from "../utils/booking.utils";

const BookingsTable = ({ bookings, onConfirm, isConfirming }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped align-middle">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Vehicle</th>
            <th>Driver</th>
            <th>Route</th>
            <th>Pickup</th>
            <th>Dropoff</th>
            <th>Amount</th>
            <th>Overtime</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking) => {
            const customerName = booking?.customerSnapshot?.name || booking?.fullName || "-";
            const companyName = booking?.customerSnapshot?.companyName || booking?.companyName || "-";
            const customerPhone = booking?.customerSnapshot?.phoneNumber || booking?.phoneNumber || "-";

            const make = booking?.vehicleSnapshot?.make || "";
            const model = booking?.vehicleSnapshot?.model || "";
            const year = booking?.vehicleSnapshot?.year || "";
            const regNo = booking?.vehicleSnapshot?.registrationNumber || "-";

            const driverName = booking?.driverSnapshot?.name || "-";
            const driverContact = booking?.driverSnapshot?.contactNumber || "-";

            const overtimeType = booking?.overtime?.chargeType || "none";
            const overtimeAmount = booking?.overtime?.overtimeAmount || 0;

            return (
              <tr key={booking?._id || `${booking?.customerId}-${booking?.vehicleId}`}>
                <td>
                  <div className="fw-semibold">{customerName}</div>
                  <small className="text-muted d-block">{companyName}</small>
                  <small className="text-muted d-block">{customerPhone}</small>
                </td>

                <td>
                  <div className="fw-semibold">{[make, model].filter(Boolean).join(" ") || "-"}</div>
                  <small className="text-muted d-block">{year || "-"}</small>
                  <small className="text-muted d-block">{regNo}</small>
                </td>

                <td>
                  <div className="fw-semibold">{driverName}</div>
                  <small className="text-muted d-block">{driverContact}</small>
                </td>

                <td>
                  <div className="fw-semibold">{booking?.pickupLocation || "-"}</div>
                  <small className="text-muted d-block">to {booking?.dropoffLocation || "-"}</small>
                </td>

                <td>{formatBookingDateTime(booking?.pickupDateTime)}</td>
                <td>{formatBookingDateTime(booking?.dropoffDateTime)}</td>
                <td>{formatBookingAmount(booking?.totalAmount)}</td>

                <td>
                  <div className="text-capitalize">{overtimeType.replace("_", " ")}</div>
                  <small className="text-muted d-block">{formatBookingAmount(overtimeAmount)}</small>
                </td>

                <td>
                  <span className={getBookingStatusBadgeClass(booking?.status)}>
                    {(booking?.status || "unknown").replace("_", " ")}
                  </span>
                </td>

                <td>
                  {booking?.status === "pending" ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => onConfirm(booking)}
                      disabled={isConfirming}
                    >
                      Confirm
                    </button>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BookingsTable;
